import { useState } from 'react';
import Icon from '@/vm/Icon';
import { imageUrl } from '@/vm/Shared/imageUrl';
import ReturnPolicyModal from '@/vm/Shared/modals/ReturnPolicyModal';
import { YellowHorizontal } from '@/vm/Shared/YellowHorizontal.styles';
import {
  GraphicWrapper,
  BottomNote,
  BottomImage,
  BottomText,
  Icons
} from './Step.styles';
import { TitleWrapper } from '../Shared/Shared.styles';

export default function Steps() {
  const [isReturnPolicyModalOpen, setIsReturnPolicyModalOpen] = useState(false);

  return (
    <>
      <YellowHorizontal />
      <TitleWrapper>
        <h2>What to expect during your visit</h2>
      </TitleWrapper>
      <Icons>
        <GraphicWrapper>
          <Icon
            labelOne="Insert Your Token"
            imageFilename="insert-coin.png"
            number="1"
            position="alignLeft"
          />
          <Icon
            labelOne="Watch Your Car"
            labelTwo="Being Retrieved"
            imageFilename="retrieve-vehicle.png"
            number="2"
            position="alignRight"
          />
          <Icon
            labelOne="Take It"
            labelTwo="For a Spin"
            imageFilename="test-drive.png"
            number="3"
            position="alignLeft"
          />
          <Icon
            labelOne="Sign and Drive It"
            imageFilename="drive-home.png"
            number="4"
            position="alignRight"
          />
        </GraphicWrapper>
      </Icons>
      <BottomNote>
        <BottomImage>
          <img
            alt="Test Own"
            src={imageUrl('test-own.png')}
            width="60px"
            height="60px"
          />
        </BottomImage>
        <BottomText>
          <h3>7-Day Money Back Guarantee</h3>
          <p>
            Have peace of mind knowing that you have 7 days to love it or return
            it.
          </p>
          <span
            data-analytics-id="Learn More"
            onClick={() => setIsReturnPolicyModalOpen(true)}
          >
            Learn More
          </span>
        </BottomText>
      </BottomNote>

      <ReturnPolicyModal
        isOpen={isReturnPolicyModalOpen}
        onClose={() => setIsReturnPolicyModalOpen(false)}
      />
    </>
  );
}
